import MCLib from '../static/js/mc-lib';
import getStackUrl from './getStackUrl';

const LOGOUT_PATH = '/ecs/logout';
const stackUrl = getStackUrl();

const mcLib = new MCLib({ allowedOrigin: stackUrl, mc: window.top });
mcLib.initData();

mcLib.registerLogoutUrl(window.location.origin + LOGOUT_PATH);

export default mcLib;
